import { render, staticRenderFns } from "./InvoiceHistoryRejectForm.vue?vue&type=template&id=21d452f6"
import script from "./InvoiceHistoryRejectForm.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryRejectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports